import { useEffect } from "react"
import GlobalContext, { GlobalStateSchema } from "../context/GlobalContext"
import type { SchemaElement } from "../context/StateSchema"

export const QueryParameters = Object.freeze({
  TOKEN: "token",
  LANGUAGE: "lang",
} as const)

type QueryParameterValue =
  (typeof QueryParameters)[keyof typeof QueryParameters]

const ValidQPSet: readonly string[] = Object.values(QueryParameters)

interface ParsedQueryParams {
  [key: string]: string[]
}

const parseQueryParams = (): ParsedQueryParams | null => {
  const isBrowser = typeof window !== "undefined"
  if (!isBrowser) {
    return null
  }

  const searchParams = new URLSearchParams(window.location.search)
  const paramObject: ParsedQueryParams = {}
  for (const key of searchParams.keys()) {
    const qp = key.toString().toLowerCase()
    if (ValidQPSet.includes(qp) && paramObject[qp] === undefined) {
      paramObject[qp] = searchParams.getAll(qp)
    }
  }

  return paramObject
}

export const usePopulateStateWithQParams = (): void => {
  const qpDispatch = GlobalContext.useDispatch(
    GlobalStateSchema.queryParams as any as SchemaElement
  )
  useEffect(() => {
    const params = parseQueryParams()
    qpDispatch(params)
  }, []) // Empty dependency array - only run once on mount
}

export const useQueryParams = () => {
  return GlobalContext.useState(
    GlobalStateSchema.queryParams as any as SchemaElement
  )
}
